module.exports = __webpack_public_path__ + "img/clase_andaluz.3ca16e4c.webp";